import {HeatProfile, isMoodLightId} from '../types';

// TODO: Remove tempporary function when the rest of mood light builds are in
export const getMoodLightColor = (profile: HeatProfile): string => {
  return isMoodLightId(profile.light)
    ? '#000000' // TODO: use multicolor gradient
    : profile.light.color;
};
